'use client';

import React from 'react';
import { useTimePilotT } from '@/i18n/useTimePilotT';
import type { ScopesObject } from '@/shared/types';
import {
  ChatEvidenceLockerProvider,
  type ChatEvidenceLockerContextValue,
} from '../chat-evidence-locker-context-new';
import { EvidenceLockerPanelNew } from '../evidence-locker-panel-new';
import { TimelineScopeSummary } from './timeline-scope-summary';

export type TimelineScopePickerViewProps = {
  caseId: string;
  scopes: ScopesObject;
  onScopesChange: ChatEvidenceLockerContextValue['setScopesAndFiles'];
  /** Panel close control returns to the details view. */
  onBack: () => void;
  onPreviewPopoverOpenChange?: (open: boolean) => void;
};

export function TimelineScopePickerView({
  caseId,
  scopes,
  onScopesChange,
  onBack,
  onPreviewPopoverOpenChange,
}: TimelineScopePickerViewProps) {
  const t = useTimePilotT();
  return (
    <ChatEvidenceLockerProvider
      caseId={caseId}
      scopesAndFiles={scopes}
      setScopesAndFiles={onScopesChange}
    >
      <div className="flex h-[min(60vh,560px)] min-h-[360px] gap-3">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-md">
          <EvidenceLockerPanelNew
            isActive
            appearance="inverse"
            showCloseButton={false}
            onClose={onBack}
            onPreviewPopoverOpenChange={onPreviewPopoverOpenChange}
            treeHeightClassName="min-h-0 flex-1"
          />
        </div>
        <aside className="flex w-72 shrink-0 flex-col overflow-y-auto">
          <TimelineScopeSummary
            scopes={scopes}
            onChange={onScopesChange}
            title={t('timelineCreate.scopedItems')}
            emptyText={t('timelineCreate.nothingScoped')}
            inverse
          />
        </aside>
      </div>
    </ChatEvidenceLockerProvider>
  );
}
